import { render, staticRenderFns } from "./IdentificationList.vue?vue&type=template&id=1a9ba889&"
import script from "./IdentificationList.vue?vue&type=script&lang=js&"
export * from "./IdentificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports